import React from 'react';
import Message from '../../../../../components/common/Message';
import Input from 'epic-diesel-form/src/components/form/Input';
import {FormsySchema, PayoutSchemaKeys} from '../../../../../data/formsy';

//@ts-ignore
import styles from './Payout.pcss';

export interface PaypalProps {
    messages: Record<string, string>;
    accountEmail: string;
    trigger: (key: string, value: any) => void;
    disabled?: boolean;
    schema: FormsySchema<PayoutSchemaKeys>;
}

const Paypal: React.FC<PaypalProps> = ({
    messages,
    accountEmail = '',
    trigger,
    disabled,
    schema
}) => {
    const onChange = event => {
        const {name, value} = event.target;
        trigger(name, value);
    };

    return (
        <div className={styles.section}>
            <h2>
                <Message code="epic.affiliate.settings.paypal_title" />
            </h2>
            <p />
            <div className={styles.row}>
                <div>
                    <Input
                        required
                        disabled={disabled}
                        autoComplete="off"
                        type="email"
                        id={schema.payPal.identifier}
                        name={schema.payPal.identifier}
                        value={accountEmail}
                        placeholder={schema.payPal.display.text}
                        validations={schema.payPal.validations}
                        validationErrors={schema.payPal.validationMessages}
                        onChange={onChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default Paypal;
